/**
 * Entry module of every site page (loaded as a deferred ES module). Shared
 * parts start everywhere; page parts by <body data-page>.
 */

import { initAccount } from "./account";
import { initAnalytics } from "./analytics";
import { initAuthUi } from "./auth-ui";
import { initConverter } from "./converter/page";
import { initInbox } from "./inbox";
import { initDialogs } from "./lib/dialog";
import { initErrorReporting } from "./lib/report";
import { initReset } from "./reset";
import { initSession, isPremium, loadMe } from "./session";
import { initSignup } from "./signup";
import { initWebToPdf } from "./webtopdf";

function start(): void {
  initErrorReporting(); // first: failures of the other parts are reported
  initAnalytics();
  initDialogs();
  initSignup();
  initAuthUi();
  void initSession();

  let premium = false;
  void loadMe().then((visitor) => {
    premium = isPremium(visitor);
  });
  const inbox = initInbox(() => premium);

  const page = document.body.dataset["page"];
  if (page === "converter") {
    initConverter(inbox);
    initWebToPdf(inbox);
  } else if (page === "account") {
    initAccount();
  } else if (page === "reset") {
    initReset();
  }
}

start();
